const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export function resolveImage(url) {
  if (!url) return "";
  if (url.startsWith("/api/uploads/") || url.startsWith("/uploads/")) {
    const normalized = url.startsWith("/uploads/") ? `/api${url}` : url;
    return `${BACKEND_URL}${normalized}${normalized.includes("?")?"&":"?"}v=2`;
  }
  return url;
}
